import { render } from "./Ps5.vue?vue&type=template&id=ec9c484a"
import script from "./Ps5.vue?vue&type=script&lang=js"
export * from "./Ps5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__